import React, { useEffect } from 'react';
import { format } from 'date-fns';
import { useSelector } from 'react-redux';
import { DATE_FORMAT } from '@yme/molecules/date-picker/constants';
import { getRTL } from '@yme/selectors/common';
import { DigitalDataMutation, setDigitalData } from '@yme/utils/common';
import { IndentWrapper } from '../Separator';
import { HeroSectionHeader } from './HeroSectionHeader';
import { HeroSectionMainContent } from './HeroSectionMainContent';
export function HeroSection(props) {
    const { backgroundImage, button, countryFlag, date, dateFrom, dateTo, description, eventLogo, labels, locationTitle, mapLink, price, subtitle, title, currencyCode, isRemoveBottomIndent, } = props;
    const isRightToLeft = useSelector(getRTL);
    useEffect(() => {
        if (title && date) {
            setDigitalData(DigitalDataMutation.EVENTS_DETAILS_VIEW, {
                headline: title,
                publishDate: format(date, DATE_FORMAT['dd/MM/yyyy']),
                label: '',
            });
        }
    }, [date, title]);
    if (!backgroundImage ||
        !date ||
        !dateFrom ||
        !dateTo ||
        !description ||
        !title ||
        !subtitle ||
        !currencyCode) {
        return null;
    }
    return (React.createElement(IndentWrapper, { isRemoveBottomIndent: isRemoveBottomIndent },
        React.createElement("section", { ...(isRightToLeft
                ? {
                    dir: 'rtl',
                }
                : {}) },
            React.createElement(HeroSectionHeader, { backgroundImage: backgroundImage, date: date, eventLogo: eventLogo, countryFlag: countryFlag, subtitle: subtitle, title: title }),
            React.createElement(HeroSectionMainContent, { title: title, dateFrom: dateFrom, dateTo: dateTo, description: description, button: button, currencyCode: currencyCode, locationTitle: locationTitle, price: price, mapLink: mapLink, viewMapLabel: labels.eventsHeroSection_viewMap_link }))));
}
HeroSection.displayName = 'HeroSection_AEMComponent';
